// DS5.2
import React from 'react';
import c from 'classnames';
import Tabs, { Props as TabsProps } from '../..';
import s from './UnderlinedTabs.scss';
import tabStyles from './UnderlinedTab.scss';

export type Props = Omit<TabsProps, 'viewClassNames'> & {
  size?: 'small' | 'medium' | 'big';
  uniformTabWidth?: boolean; // uniformTabWidth = false - DS5.2.1
  tabClassName?: string;
};

export const UnderlinedTabs = React.forwardRef<any, Props>(
  ({ size = 'small', uniformTabWidth, items, tabClassName, ...props }, ref) => {
    return (
      <Tabs
        {...props}
        ref={ref}
        items={items.map(item => {
          if (item.hasNotification) {
            const modifiedItem = {
              ...item,
              labelExtras: <div className={s['notification-dot']} />,
            };
            return modifiedItem;
          }
          return item;
        })}
        viewClassNames={{
          root: c(s['root'], s[size], uniformTabWidth && s['uniform-tabs']),
          tab: c(s['tab'], tabStyles['tab'], tabStyles[size], tabClassName),
          label: tabStyles['label'],
          prefix: tabStyles['prefix'],
          dropdown: tabStyles['dropdown'],
          'active-tab': tabStyles['active-tab'],
        }}
      />
    );
  }
);
UnderlinedTabs.displayName = 'UnderlinedTabs';

export default UnderlinedTabs;
